module.exports = __webpack_public_path__ + "media/images/icons/outlined/aliwangwang-fa9970731556902bee6726f39fa1b667.svg";